
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $fe01a7f2f1ca3698$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["jLrUC","index.900f2512.js","ku7iv","../ui-pack.01f87fb1.aac","ggPgC","../Dial_up_modem_noises.fcf212dc.aac","lB7gZ","../fan-loop.00ef9ea2.wav","5pTAp","../RAIN_Heavy_loop_stereo_01.a46bc133.aac","9Zoq5","../HZ_Allo.df799dd6.mp3","hOllM","../HZ_Vocal.d7be1088.mp3","9wnIs","../HZ_Merci.1af0b4b4.mp3"]'));

// Autrona Acoustic Computer Kernel Module: Audio
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $8cf8d73fe06466d9$exports = {};

$parcel$export($8cf8d73fe06466d9$exports, "load", function () { return $8cf8d73fe06466d9$export$11e63f7b0f3d9900; });
$parcel$export($8cf8d73fe06466d9$exports, "play", function () { return $8cf8d73fe06466d9$export$899fbdb5fa08b653; });
$parcel$export($8cf8d73fe06466d9$exports, "audioBuffers", function () { return $8cf8d73fe06466d9$export$c2a342ec653dfb48; });
// Audio kernel module: Buffer
// Manages loading, decoding and plaback of audioBuffers

// References
const $8cf8d73fe06466d9$export$c2a342ec653dfb48 = {};
function $8cf8d73fe06466d9$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            resolve($8cf8d73fe06466d9$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $8cf8d73fe06466d9$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $29df19f14cf0b965$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $8cf8d73fe06466d9$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
function $8cf8d73fe06466d9$export$899fbdb5fa08b653(name, options = {}) {
    if ($8cf8d73fe06466d9$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    $29df19f14cf0b965$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $29df19f14cf0b965$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $29df19f14cf0b965$export$a078c61943f9dbbe.createGain();
    if (options.initialGain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($29df19f14cf0b965$export$33ed28de027e9482(options.initialGain), $29df19f14cf0b965$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $29df19f14cf0b965$export$549ee30ac73cf40b; // custom function
    source.fade = $29df19f14cf0b965$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $29df19f14cf0b965$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $29df19f14cf0b965$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $8cf8d73fe06466d9$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $29df19f14cf0b965$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer === undefined) source.start(when, offset, duration);
    // Maintain references to this source
    $29df19f14cf0b965$export$d1d41f0cda037248.push(source);
    return source;
}


// References
let $29df19f14cf0b965$export$a078c61943f9dbbe;
const $29df19f14cf0b965$export$d1d41f0cda037248 = [];
function $29df19f14cf0b965$export$2cd8252107eb640b() {
    // Create AudioContext
    if (typeof AudioContext !== "undefined") $29df19f14cf0b965$export$a078c61943f9dbbe = new AudioContext();
    else // For Safari
    $29df19f14cf0b965$export$a078c61943f9dbbe = new webkitAudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $29df19f14cf0b965$export$a078c61943f9dbbe.sampleRate);
}
function $29df19f14cf0b965$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($29df19f14cf0b965$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $29df19f14cf0b965$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $29df19f14cf0b965$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($29df19f14cf0b965$export$33ed28de027e9482(fromLevel), $29df19f14cf0b965$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($29df19f14cf0b965$export$33ed28de027e9482(level), $29df19f14cf0b965$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($29df19f14cf0b965$export$33ed28de027e9482(level), $29df19f14cf0b965$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $29df19f14cf0b965$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $29df19f14cf0b965$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $29df19f14cf0b965$export$33ed28de027e9482(db), $29df19f14cf0b965$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $29df19f14cf0b965$export$33ed28de027e9482(db), $29df19f14cf0b965$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($29df19f14cf0b965$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $29df19f14cf0b965$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $29df19f14cf0b965$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $29df19f14cf0b965$export$33390c3a9a83a2f() {
    $29df19f14cf0b965$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $29df19f14cf0b965$export$93c25f2590a5b540(source) {
    const index = $29df19f14cf0b965$export$d1d41f0cda037248.indexOf(source);
    $29df19f14cf0b965$export$d1d41f0cda037248.splice(index, 1);
}
function $29df19f14cf0b965$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $29df19f14cf0b965$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}


// Autrona Acoustic Computer Kernel Module: Screen
// Handle all text screen drawing, save/restore, lines management, styles,
// teletype animations and sequences of this UNIX-like terminal emulation.
// Utilities
//
// Project-wide utility functions
function $bbbdb3460c24deda$export$10ce5528abfb398a(source, dest) {
    // Overwrite destination object values for keys that exists in the source object
    Object.getOwnPropertyNames(dest).forEach((key)=>{
        if (Object.prototype.hasOwnProperty.call(source, key)) dest[key] = source[key];
    });
}
// Extract lines from a long string at word breaks before given length param
// Return an array of trimmed lines
function $bbbdb3460c24deda$export$89440da1893f4202(str, length) {
    const lines = [];
    if (str.length <= length) lines.push(str);
    else {
        let s = str;
        while(s.length > 0){
            let line;
            if (s.length > length) line = s.slice(0, s.slice(0, length).lastIndexOf(" "));
            else line = s;
            if (line.length > 0) {
                s = s.slice(line.length);
                lines.push(line.trim());
            } else s = "";
        }
    }
    return lines;
}
function $bbbdb3460c24deda$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(value, max));
}
function $bbbdb3460c24deda$var$constrain(n, low, high) {
    return Math.max(Math.min(n, high), low);
}
let $bbbdb3460c24deda$var$newval;
function $bbbdb3460c24deda$export$aee1dbae5de2db9d(n, start1, stop1, start2, stop2, withinBounds) {
    $bbbdb3460c24deda$var$newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
    if (!withinBounds) return $bbbdb3460c24deda$var$newval;
    if (start2 < stop2) return $bbbdb3460c24deda$var$constrain($bbbdb3460c24deda$var$newval, start2, stop2);
    return $bbbdb3460c24deda$var$constrain($bbbdb3460c24deda$var$newval, stop2, start2);
}



// Autrona Acoustic Computer Kernel Module: Keyboard
// Handle all key strokes, keep track of modifiers, 
// then pass the events to the currently running program,
// including main for control-sequences
// Configuration
const $5129ed2d4f40dc24$var$modifiers = [
    "Control"
];
const $5129ed2d4f40dc24$var$defaultPrevented = [
    " ",
    "ArrowUp",
    "ArrowDown"
];
// Variables
const $5129ed2d4f40dc24$export$58b6cc66cb100704 = [];
// Initialize module
function $5129ed2d4f40dc24$export$2cd8252107eb640b() {
    document.addEventListener("keydown", $5129ed2d4f40dc24$var$handleKeyDowns);
    document.addEventListener("keyup", $5129ed2d4f40dc24$var$handleKeyUps);
}
// General keydown event callback
function $5129ed2d4f40dc24$var$handleKeyDowns(e) {
    //console.log('Keystroke:', e.key)
    if ($5129ed2d4f40dc24$var$modifiers.includes(e.key)) $5129ed2d4f40dc24$var$addModifier(e.key);
    if ($5129ed2d4f40dc24$var$defaultPrevented.includes(e.key)) e.preventDefault();
}
// keyup event callback
function $5129ed2d4f40dc24$var$handleKeyUps(e) {
    if ($5129ed2d4f40dc24$var$modifiers.includes(e.key)) $5129ed2d4f40dc24$var$removeModifier(e.key);
}
// Modifier keys handling
function $5129ed2d4f40dc24$var$addModifier(key) {
    $5129ed2d4f40dc24$export$58b6cc66cb100704.push(key);
}
function $5129ed2d4f40dc24$var$removeModifier(key) {
    const modifierIndex = $5129ed2d4f40dc24$export$58b6cc66cb100704.indexOf(key);
    $5129ed2d4f40dc24$export$58b6cc66cb100704.splice(modifierIndex, 1);
}


// Variables
let $e54f537527899e63$var$screen;
let $e54f537527899e63$var$container;
let $e54f537527899e63$var$saveBuffer;
let $e54f537527899e63$var$unveilBuffer;
let $e54f537527899e63$var$currentLine;
let $e54f537527899e63$var$overflow = "scroll"; // scroll or clear
let $e54f537527899e63$var$timeout;
let $e54f537527899e63$var$timeoutBis;
const $e54f537527899e63$var$screenCols = 80;
const $e54f537527899e63$var$screenLines = 42;
// Initialize module
function $e54f537527899e63$export$2cd8252107eb640b() {
    $e54f537527899e63$var$screen = document.querySelector(".screen");
    $e54f537527899e63$var$container = document.querySelector(".container");
}
function $e54f537527899e63$export$c63191ea74413a1c(mode) {
    $e54f537527899e63$var$overflow = mode;
}
function $e54f537527899e63$export$a1544dad697b423d() {
    $e54f537527899e63$var$saveBuffer = $e54f537527899e63$var$screen.innerHTML;
}
function $e54f537527899e63$export$db239ef39aadc7fe() {
    clearTimeout($e54f537527899e63$var$timeout);
    clearTimeout($e54f537527899e63$var$timeoutBis);
    $e54f537527899e63$var$screen.innerHTML = $e54f537527899e63$var$saveBuffer;
    $e54f537527899e63$var$currentLine = $e54f537527899e63$var$screen.querySelector("p:last-of-type");
}
function $e54f537527899e63$export$42ffd38884aecdac(includePinned = true) {
    if (includePinned) {
        $e54f537527899e63$var$screen.innerHTML = "";
        $e54f537527899e63$var$currentLine = null;
        clearTimeout($e54f537527899e63$var$timeout);
        clearTimeout($e54f537527899e63$var$timeoutBis);
    } else $e54f537527899e63$var$screen.querySelectorAll("p:not(.pinned)").forEach((p)=>p.remove());
}
function $e54f537527899e63$export$10d8903dec122b9d(content, ...style) {
    if (style.length) $e54f537527899e63$export$3086f70939fb96fa(...style);
    $e54f537527899e63$var$currentLine.innerText += content;
    if (DEVMODE) $e54f537527899e63$var$checkLineLength($e54f537527899e63$var$currentLine.innerText);
    $e54f537527899e63$var$scroll();
}
function $e54f537527899e63$export$57ec1e98c75cb636(content, ...style) {
    if (style.length) $e54f537527899e63$export$3086f70939fb96fa(...style);
    $e54f537527899e63$var$currentLine.innerHTML += content;
    if (DEVMODE) $e54f537527899e63$var$checkLineLength($e54f537527899e63$var$currentLine.innerText);
    $e54f537527899e63$var$scroll();
}
function $e54f537527899e63$var$scroll() {
    // Scroll to bottom if necessary
    if ($e54f537527899e63$var$container.scrollTop !== $e54f537527899e63$var$container.scrollHeight) setTimeout(()=>{
        $e54f537527899e63$var$container.scrollTop = $e54f537527899e63$var$container.scrollHeight;
    }, 0);
}
function $e54f537527899e63$export$21a5ca8aa77d35ff(content, ...style) {
    $e54f537527899e63$export$dc84f6841f96b7da();
    $e54f537527899e63$export$10d8903dec122b9d(content, ...style);
}
function $e54f537527899e63$export$5a813221cd493211(content, ...style) {
    $e54f537527899e63$export$dc84f6841f96b7da();
    $e54f537527899e63$export$57ec1e98c75cb636(content, ...style);
}
function $e54f537527899e63$export$296e2d3e74e50369(content, ...style) {
    content.split("\n").forEach((c)=>$e54f537527899e63$export$21a5ca8aa77d35ff(c, ...style));
}
function $e54f537527899e63$export$91698095bd4ff7e0(content, ...style) {
    content.split("\n").forEach((c)=>$e54f537527899e63$export$5a813221cd493211(c, ...style));
}
function $e54f537527899e63$var$checkLineLength(content) {
    if (content.length > $e54f537527899e63$var$screenCols) console.warn("Warning: Content is larger than screen columns: " + content.length, content);
}
// Delete one (or more if specified) characters from the screenBuffer
function $e54f537527899e63$export$1ea584ca7009bcc1(n = 1) {
    $e54f537527899e63$var$currentLine.innerText = $e54f537527899e63$var$currentLine.innerText.slice(0, -n);
}
function $e54f537527899e63$export$dc84f6841f96b7da() {
    // Remove blinking cursor and/or dots if active
    if ($e54f537527899e63$var$currentLine) $e54f537527899e63$var$currentLine.classList.remove("cursor");
    if ($e54f537527899e63$var$currentLine) $e54f537527899e63$var$currentLine.classList.remove("dots");
    // Limit screen rows to screenLines
    if ($e54f537527899e63$var$screen.querySelectorAll("p").length >= $e54f537527899e63$var$screenLines) {
        if ($e54f537527899e63$var$overflow === "clear") $e54f537527899e63$export$42ffd38884aecdac(false);
        else // Remove the first paragraph which is not pinned
        $e54f537527899e63$var$screen.querySelector("p:not(.pinned)").remove();
    }
    // Create a new paragraph
    const p = document.createElement("p");
    $e54f537527899e63$var$screen.appendChild(p);
    $e54f537527899e63$var$currentLine = p;
}
function $e54f537527899e63$export$b78008adb124fd21(n = 1) {
    for(let i = 0; i < n; i++){
        $e54f537527899e63$var$currentLine.remove();
        $e54f537527899e63$var$currentLine = $e54f537527899e63$var$screen.querySelector("p:last-of-type");
    }
}
function $e54f537527899e63$export$3086f70939fb96fa(...style) {
    $e54f537527899e63$var$currentLine.classList.add(...style);
}
function $e54f537527899e63$export$35bfa795e607ffd5() {
    $e54f537527899e63$var$currentLine.classList.add("pinned");
}
function $e54f537527899e63$export$58734539bbfa41a2() {
    $e54f537527899e63$var$currentLine.classList.add("cursor");
}
function $e54f537527899e63$export$e5383273bc7bedd() {
    // add three bouncing animated dots
    $e54f537527899e63$var$currentLine.classList.add("dots");
}
function $e54f537527899e63$export$6c9a7cc621cd09fe() {
    if ($e54f537527899e63$var$currentLine) $e54f537527899e63$var$currentLine.classList.remove("dots");
}
function $e54f537527899e63$export$36a3a8a63357453b(content, n = null) {
    if (n == null) n = $e54f537527899e63$var$screen.querySelectorAll("p").length;
    $e54f537527899e63$var$screen.querySelector(`p:nth-child(${n})`).innerHTML = content;
}
function $e54f537527899e63$export$14c7f8fd9e0dc60b() {
    const linesToFill = $e54f537527899e63$var$screenLines - $e54f537527899e63$var$screen.querySelectorAll("p").length;
    for(let i = 0; i < linesToFill; i++)$e54f537527899e63$export$dc84f6841f96b7da();
}
// Automated teletype
// Will append `string` to the current line one character at a time,
// with `delay` milliseconds between each character.
function $e54f537527899e63$export$5938cf5cddbfce5a(string, delay = 33, callback = null) {
    if (string.length > 0) {
        let charDelay = delay;
        if (delay === "00" || delay == "human") charDelay = Math.floor(Math.random() * 8) ** 2 + 50;
        // Handle inline delays
        let inlineDelayMatch = string.match(/^(§([0-9]+)).*$/);
        if (inlineDelayMatch) {
            charDelay = inlineDelayMatch[2];
            string = string.replace(inlineDelayMatch[1], "").trim();
        }
        // Remove delays for development
        if (DEVMODE && $5129ed2d4f40dc24$export$58b6cc66cb100704.includes("Control")) charDelay = 16;
        $e54f537527899e63$var$timeout = setTimeout(()=>{
            if (string.slice(0, 1) === "\xa7") $e54f537527899e63$export$1ea584ca7009bcc1();
            else $e54f537527899e63$export$10d8903dec122b9d(string.slice(0, 1));
            string = string.slice(1);
            $e54f537527899e63$export$5938cf5cddbfce5a(string, delay, callback);
        }, charDelay);
    } else if (typeof callback == "function") callback();
}
// Screen sequence
// A sequence of steps, each can be of different types
//  `Any text`         (string).     Will append the text to the current line.
//  `!n`               (new line).   Will open a new line.
//  `!c`               (clear).      Will clear the screen
//  `!s:my-class`      (CSS class).  Will add 'my-class' to the current line.
//  `!t:anytext:delay` (teletype).   Will teletype a string with given delay between each character
//  `!H:anytext      ` (HTML).       Will append the HTML to the current line.
//  `500`              (number).     Will delay further steps by X milliseconds.
function $e54f537527899e63$export$49bb65c2ea163039(seq, callback) {
    if (seq.length > 0) {
        const step = seq[0];
        if (typeof step == "string") {
            let matchNewLine = step.match(/^!n$/);
            let matchClear = step.match(/^!c$/);
            let matchStyle = step.match(/^!s:([a-z0-9\-]+)$/);
            let matchTeletype = step.match(/^!t:(.+):([0-9]+)$/);
            let matchHTML = step.match(/^!h:(.+)$/);
            switch(true){
                case matchNewLine != null:
                    $e54f537527899e63$export$dc84f6841f96b7da();
                    break;
                case matchClear != null:
                    $e54f537527899e63$export$42ffd38884aecdac();
                    break;
                case matchStyle != null:
                    $e54f537527899e63$export$3086f70939fb96fa(matchStyle[1]);
                    break;
                case matchTeletype != null:
                    $e54f537527899e63$export$5938cf5cddbfce5a(matchTeletype[1], matchTeletype[2], ()=>{
                        // When teletype finished, recursively step ahead in sequence
                        $e54f537527899e63$export$49bb65c2ea163039(seq.slice(1), callback);
                    });
                    break;
                case matchHTML != null:
                    $e54f537527899e63$export$57ec1e98c75cb636(matchHTML[1]);
                    break;
                default:
                    $e54f537527899e63$export$10d8903dec122b9d(step);
            }
            // Recursively step ahead in sequence
            if (!matchTeletype) $e54f537527899e63$export$49bb65c2ea163039(seq.slice(1), callback);
        } else if (typeof step == "number") // Recursively step ahead in sequence with a milliseconds delay
        $e54f537527899e63$var$timeout = setTimeout(()=>{
            $e54f537527899e63$export$49bb65c2ea163039(seq.slice(1), callback);
        }, step);
    } else callback();
}
// New screen sequence
// A sequence of multi-line text which is to be rendered on screen
// Default mode is teletype, each caracter appended to screen one at a time
// with human-like timing.
// Handles a post-lead line delay token in the sequence: '§2000' for a 2s delay
// TODO: BBCode-like markup: (Should be implemented in teletype fonction ?)
//   - [s:col-green]...[/s] Styling with spans
function $e54f537527899e63$export$b28a6436aebad9c0(seq, opts, callback = null) {
    const options = {
        /* Default options */ mode: "teletype",
        color: "col-orange",
        lead: "",
        lineDelay: 1000,
        dotsDelay: 2000,
        endDelay: 1000,
        newLineAtStart: true,
        newLineAtEnd: true,
        teletypeDelay: "human"
    };
    // Overwrite any default option with `opts` parameter
    $bbbdb3460c24deda$export$10ce5528abfb398a(opts, options);
    if (seq.length > 0) {
        if (options.newLineAtStart) {
            $e54f537527899e63$export$dc84f6841f96b7da();
            options.newLineAtStart = false; // To cancel new line from recursive use
        }
        // Get sequence lines as an array
        let lines = seq.split("\n");
        // Get the first line
        let line = lines[0];
        // Remove any white-space around that line (code indents mostly)
        line = line.trim();
        openLine();
        // Find optional an line delay at the string's start (`§500` for a 500ms delay)
        let lineDelay = options.lineDelay;
        let lineDelayMatch = line.match(/^(§([0-9]+)).*$/);
        if (lineDelayMatch) {
            lineDelay = lineDelayMatch[2];
            line = line.replace(lineDelayMatch[1], "").trim();
        }
        // Remove delays for development
        if (DEVMODE && $5129ed2d4f40dc24$export$58b6cc66cb100704.includes("Control")) lineDelay = 0;
        // After the first lead occurence, replace all characters with spaces
        options.lead = "".padStart(options.lead.length);
        // Prepare remaining sequence (this line excluded) for recursive use
        const remainingSeq = lines.slice(1).join("\n");
        // For teletype, display dots after 2 seconds if the line delay is longer than 2 seconds
        if (options.mode === "teletype" && lineDelay > options.dotsDelay) $e54f537527899e63$var$timeoutBis = setTimeout($e54f537527899e63$export$e5383273bc7bedd, options.dotsDelay);
        $e54f537527899e63$var$timeout = setTimeout(()=>{
            // Default mode: teletype
            switch(options.mode){
                case "line":
                    $e54f537527899e63$export$6c9a7cc621cd09fe();
                    $e54f537527899e63$export$10d8903dec122b9d(line);
                    $e54f537527899e63$export$b28a6436aebad9c0(remainingSeq, options, callback);
                    break;
                case "teletype":
                    $e54f537527899e63$export$6c9a7cc621cd09fe();
                    const lines = $bbbdb3460c24deda$export$89440da1893f4202(line, 80 - options.lead.length);
                    teletypeMultiline(lines.shift());
                    function teletypeMultiline(line) {
                        $e54f537527899e63$export$5938cf5cddbfce5a(line, options.teletypeDelay, ()=>{
                            // Handling multiline teletype
                            if (lines.length) {
                                openLine();
                                teletypeMultiline(lines.shift());
                            } else // Recursively step ahead in sequence
                            $e54f537527899e63$export$b28a6436aebad9c0(remainingSeq, options, callback);
                        });
                    }
                    break;
                case "message":
                    const charDelay = 100; // How much time per char before printing this line
                    $e54f537527899e63$export$e5383273bc7bedd();
                    $e54f537527899e63$var$timeout = setTimeout(()=>{
                        $e54f537527899e63$export$6c9a7cc621cd09fe();
                        $e54f537527899e63$export$5938cf5cddbfce5a(line, options.teletypeDelay, ()=>{
                            // Recursively step ahead in sequence
                            $e54f537527899e63$export$b28a6436aebad9c0(remainingSeq, options, callback);
                        });
                    }, line.length * charDelay);
                    break;
            }
        }, lineDelay);
    } else $e54f537527899e63$var$timeout = setTimeout(()=>{
        if (options.newLineAtEnd) $e54f537527899e63$export$dc84f6841f96b7da();
        if (callback) callback();
    }, options.endDelay);
    function openLine() {
        // Add lead
        $e54f537527899e63$export$21a5ca8aa77d35ff(options.lead);
        // Style line
        if (typeof options.color === "string") $e54f537527899e63$export$3086f70939fb96fa(options.color);
        else $e54f537527899e63$export$3086f70939fb96fa(...options.color);
    }
}
function $e54f537527899e63$export$d5cd9e826e7bdb85(callback) {
    // Analogue to save() but need its own buffer to keep save buffer intact
    $e54f537527899e63$var$unveilBuffer = $e54f537527899e63$var$screen.innerHTML;
    $e54f537527899e63$export$42ffd38884aecdac();
    const paragraphs = $e54f537527899e63$var$unveilBuffer.split("p><p");
    paragraphs.map((p, i)=>{
        if (i === 0) paragraphs[i] += "p>";
        else if (i === paragraphs.length - 1) paragraphs[i] = "<p" + paragraphs[i];
        else paragraphs[i] = "<p" + paragraphs[i] + "p>";
    });
    let i = 0;
    function step() {
        $e54f537527899e63$var$screen.innerHTML += paragraphs[i];
        $e54f537527899e63$var$currentLine = $e54f537527899e63$var$screen.querySelector("p:last-of-type");
        if (i < paragraphs.length - 1) $e54f537527899e63$var$timeout = setTimeout(step, LSI);
        else if (typeof callback === "function") callback();
        i++;
    }
    step();
}
// Display a choice list with optional title to be answered with a key press
// `answers` param is an object: { keyName: [answerText, callback]}
// Example:
//  screen.choice('Votre réponse:', {
//      '1': ['Ben.. Je sais pas trop...', passageB],
//      '2': ['Heu... Je vois rien...', passageC],
//  });
// Would yield:
//  Votre réponse:
//    [1] Ben.. Je sais pas trop...
//    [2] Heu... Je vois rien...
//  > 
function $e54f537527899e63$export$7a5825874deea16a(title, answers) {
    // Display optional title
    if (title) $e54f537527899e63$export$21a5ca8aa77d35ff(title);
    let seq = "";
    // Display one choice per line
    for (const [key, answer] of Object.entries(answers)){
        const indent = 5 + key.length;
        const maxLength = 80 - indent;
        const lines = $bbbdb3460c24deda$export$89440da1893f4202(answer[0], maxLength);
        lines.forEach((line, index)=>{
            if (index === 0) seq += `[${key}] ${line}\n`;
            else seq += "".padStart(indent) + line + "\n";
        });
    }
    $e54f537527899e63$export$b28a6436aebad9c0(seq.trim(), {
        color: "col-dark-cyan",
        lead: "  ",
        lineDelay: 100,
        endDelay: 100,
        mode: "line",
        newLineAtStart: false,
        newLineAtEnd: false
    }, ()=>{
        // Display prompt
        $e54f537527899e63$export$21a5ca8aa77d35ff("> ", "col-cyan");
        $e54f537527899e63$export$58734539bbfa41a2();
        $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
    });
    registerKeyDownEvent();
    // Local one-time event listener
    function registerKeyDownEvent() {
        document.addEventListener("keydown", (e)=>{
            const answer = Object.entries(answers).find((answer)=>answer[0] === e.key);
            if (answer) {
                $e54f537527899e63$export$10d8903dec122b9d(answer[1][0]);
                $9a5e2f4e9f369aad$export$a23ad60f6022999e("validate");
                answer[1][1]();
            } else {
                console.log("Invalid answer given:", e.key);
                registerKeyDownEvent();
            }
        }, {
            once: true
        });
    }
}
function $e54f537527899e63$export$34c871b8a7d7e324(title, callback) {
    // Display optional title
    if (title) $e54f537527899e63$export$21a5ca8aa77d35ff(title);
    // Display prompt
    $e54f537527899e63$export$21a5ca8aa77d35ff("> ", "col-cyan");
    $e54f537527899e63$export$58734539bbfa41a2();
    $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
    registerKeyDownEvent();
    let answer = "";
    // Local one-time event listener
    function registerKeyDownEvent() {
        document.addEventListener("keydown", (e)=>{
            if (e.key == "Enter") {
                $9a5e2f4e9f369aad$export$a23ad60f6022999e("validate");
                callback(answer);
            } else if (e.key == "Backspace") {
                if (answer.length) {
                    // Remove last keystroke from command line on screen
                    $e54f537527899e63$export$1ea584ca7009bcc1();
                    // Remove last keystroke from command line
                    answer = answer.slice(0, -1);
                }
                registerKeyDownEvent();
            } else {
                if (e.key.length == 1) {
                    // Add keystroke to answer and screen buffer
                    answer += e.key;
                    $e54f537527899e63$export$10d8903dec122b9d(e.key);
                }
                // Enable next keystroke
                registerKeyDownEvent();
            }
        }, {
            once: true
        });
    }
}


// Autrona Acoustic Computer Program: Remote
// Connect to a remote terminal



var $1329410b119241de$exports = {};

$parcel$export($1329410b119241de$exports, "init", function () { return $1329410b119241de$export$2cd8252107eb640b; });
$parcel$export($1329410b119241de$exports, "run", function () { return $1329410b119241de$export$889ea624f2cb2c57; });
$parcel$export($1329410b119241de$exports, "keyStroke", function () { return $1329410b119241de$export$ffc3b37567fab60c; });
$parcel$export($1329410b119241de$exports, "exit", function () { return $1329410b119241de$export$5c525e238923a57d; });
// Autrona Acoustic Computer Program: Pluie
// Une première expérience



// Variables
let $1329410b119241de$var$keyBoardResponsive = false;
let $1329410b119241de$var$prompt;
let $1329410b119241de$var$userName;
let $1329410b119241de$var$nextPart = $1329410b119241de$var$part1;
let $1329410b119241de$var$rainTrack;
let $1329410b119241de$var$exitCallback;
// Initialize module
function $1329410b119241de$export$2cd8252107eb640b() {}
function $1329410b119241de$export$889ea624f2cb2c57(exitCb) {
    $1329410b119241de$var$exitCallback = exitCb;
    $1329410b119241de$var$prompt = ""; // Reset
    $1329410b119241de$var$resetScreen();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        3000,
        "!t:Votre nam \xa7\xa7\xa7om ?:00",
        500,
        "!n",
        100,
        "> "
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
        $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
        $1329410b119241de$var$enablePrompt();
    });
    document.addEventListener("keydown", $1329410b119241de$var$handleKeyDowns);
    document.addEventListener("keyup", $1329410b119241de$var$handleKeyUps);
}
// General keydown event callback
function $1329410b119241de$var$handleKeyDowns(e) {
    //console.log('Keystroke:', e.key)
    $1329410b119241de$export$ffc3b37567fab60c(e.key, "down");
}
// keyup event callback
function $1329410b119241de$var$handleKeyUps(e) {
    $1329410b119241de$export$ffc3b37567fab60c(e.key, "up");
}
function $1329410b119241de$export$ffc3b37567fab60c(key, state) {
    if (state == "down" && $1329410b119241de$var$keyBoardResponsive) switch(key){
        case "Backspace":
            if ($1329410b119241de$var$prompt.length) {
                // Remove last keystroke from command line on screen
                $e54f537527899e63$export$1ea584ca7009bcc1();
                // Remove last keystroke from command line
                $1329410b119241de$var$prompt = $1329410b119241de$var$prompt.slice(0, -1);
            }
            break;
        case "Enter":
            $9a5e2f4e9f369aad$export$a23ad60f6022999e("validate");
            $1329410b119241de$var$keyBoardResponsive = false;
            $e54f537527899e63$export$dc84f6841f96b7da();
            $1329410b119241de$var$nextPart();
            break;
        default:
            if (key.length == 1) {
                // Add keystroke to screen buffer
                $e54f537527899e63$export$10d8903dec122b9d(key);
                // Add keystroke to command line
                $1329410b119241de$var$prompt += key;
            }
    }
}
function $1329410b119241de$var$enablePrompt() {
    $1329410b119241de$var$prompt = "";
    $e54f537527899e63$export$58734539bbfa41a2();
    $1329410b119241de$var$keyBoardResponsive = true;
}
function $1329410b119241de$var$resetScreen() {
    $e54f537527899e63$export$42ffd38884aecdac();
    $e54f537527899e63$export$21a5ca8aa77d35ff(" AutronaTerm v2.5 - 802.11                                     ", "col-red", "col-bg-red");
    $e54f537527899e63$export$35bfa795e607ffd5();
    $e54f537527899e63$export$dc84f6841f96b7da();
    $e54f537527899e63$export$dc84f6841f96b7da();
}
function $1329410b119241de$var$part1() {
    $1329410b119241de$var$nextPart = $1329410b119241de$var$part2;
    $1329410b119241de$var$userName = $1329410b119241de$var$prompt;
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        `!t:Bonjour ${$1329410b119241de$var$userName} !:00`,
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Je suis tr\xe8s content de vous retrouver sur le Terminal.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:\xc7a doit bien faire quelques heures que l\u2019on ne s\u2019est pas parl\xe9.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Comment vous al:00",
        '!h:<span class="col-dark-red">&lt;!@&gt;</span>',
        "!n",
        100,
        "!s:italic",
        "!s:col-dark-red",
        "<remote connection error>",
        "!n",
        50,
        "!s:col-dark-red",
        "Hit [ENTER] to reconnect",
        "!n",
        100,
        "> "
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
        $9a5e2f4e9f369aad$export$a23ad60f6022999e("error");
        $1329410b119241de$var$enablePrompt();
    });
}
function $1329410b119241de$var$part2() {
    $1329410b119241de$var$nextPart = $1329410b119241de$var$part3;
    $1329410b119241de$var$resetScreen();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Hmm...:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:navr\xe9.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:attendez.:00",
        "!n",
        5000,
        "!s:col-green",
        "",
        500,
        "!t:Juste un instant.:00",
        "!n",
        5000,
        "!s:col-green",
        "",
        500,
        "!t:Vous \xeates l\xe0 ?:00",
        "!n",
        500,
        "Oui [1] Mouaih [2] > "
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
        $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
        $1329410b119241de$var$enablePrompt();
    });
}
function $1329410b119241de$var$part3() {
    $1329410b119241de$var$nextPart = $1329410b119241de$var$part4;
    // TODO: Remap main.backgroundTrack loopStart and loopEnd to begin ramp to rainy loop
    //       → main.setLoopMarkers(loopStart, loopEnd)
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        `!t:Navr\xe9, navr\xe9 ${$1329410b119241de$var$userName}.:00`,
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Je sais c'est p\xe9nible mais j'ai:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:j'ai un petit probl\xe8me logistique.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Attendez.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Voil\xe0 !:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:J\u2019ai un petit probl\xe8me logistique... il pleut sur le Terminal...:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:C\u2019est... c'est un Terminal ext\xe9rieur.:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:J'essaie de le couvrir avec une b\xe2che tout en vous parlant.:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:Je vous re\xe7ois mais j'ai peur de ne plus pouvoir utiliser le clav:00",
        '!h:<span class="col-dark-red">&lt;!@&gt;</span>',
        "!n",
        4000,
        "!s:col-green",
        "",
        500,
        "!t:Je disais j'ai peur d:00",
        '!h:<span class="col-dark-red">&lt;!@&gt;</span>',
        "!n",
        500,
        "!s:italic",
        "!s:col-dark-red",
        "<remote connection error>",
        "!n",
        50,
        "!s:col-dark-red",
        "Hit [ENTER] to reconnect",
        "!n",
        100,
        "> "
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
        $9a5e2f4e9f369aad$export$a23ad60f6022999e("error");
        $1329410b119241de$var$enablePrompt();
    });
    // Lancer la pluie avec un lent fade in
    const rainCrossTime = 120;
    $1329410b119241de$var$rainTrack = $8cf8d73fe06466d9$exports.play("rain", {
        loop: true,
        loopStart: 0.380,
        loopEnd: 11.121
    }).fadeTo(rainCrossTime, -18, -90, "expo");
    $9a5e2f4e9f369aad$export$3f22255af92e0d9d.fade(rainCrossTime, -18, false, "expo");
    setTimeout(()=>{
        $9a5e2f4e9f369aad$export$3f22255af92e0d9d.fade(rainCrossTime, -90, true, "expo");
    }, rainCrossTime * 1000);
}
function $1329410b119241de$var$part4() {
    $1329410b119241de$var$nextPart = $1329410b119241de$var$part5;
    $1329410b119241de$var$resetScreen();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Merci de vous \xeatre reconnect\xe9 pour qu'on puie continuer \xe0 e parler.:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:c'et vraiment tr\xe8s gentil:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Vou \xeate adorable. Vraiment.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Bien, je vou \xe9coute !:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Que pui-je faire p:00",
        '!h:<span class="col-dark-red">&lt;!@&gt;</span>',
        "!n",
        100,
        "!s:italic",
        "!s:col-dark-red",
        "<remote connection error>",
        "!n",
        50,
        "!s:col-dark-red",
        "Hit [ENTER] to reconnect",
        "!n",
        100,
        "> "
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
        $9a5e2f4e9f369aad$export$a23ad60f6022999e("error");
        $1329410b119241de$var$enablePrompt();
    });
}
function $1329410b119241de$var$part5() {
    $1329410b119241de$var$nextPart = $1329410b119241de$var$part6;
    $1329410b119241de$var$resetScreen();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Merci \xe0 nouveau.:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Pffffffffffff cette pluie... et ce goutte ur le clavier.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Je ui d\xe9ol\xe9 de vou faire endurer \xe7a !:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:Il pleut ur le clavier, je ne ai pa i vou recevez tou me texte.:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:Quelle et la lettre qui manque ?:00",
        "!n",
        100,
        "> "
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
        $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
        $1329410b119241de$var$enablePrompt();
    });
}
function $1329410b119241de$var$part6() {
    if ($1329410b119241de$var$prompt === "s") $1329410b119241de$var$part9();
    else {
        $1329410b119241de$var$nextPart = $1329410b119241de$var$part7;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Non, je ne croi pa que ce oit celle-l\xe0...:00",
            "!n",
            100,
            "> "
        ];
        $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
            $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
            $1329410b119241de$var$enablePrompt();
        });
    }
}
function $1329410b119241de$var$part7() {
    if ($1329410b119241de$var$prompt === "s") $1329410b119241de$var$part9();
    else {
        $1329410b119241de$var$nextPart = $1329410b119241de$var$part8;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Non vraiment, ce n\u2019et pa la bonne.:00",
            "!n",
            100,
            "> "
        ];
        $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
            $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
            $1329410b119241de$var$enablePrompt();
        });
    }
}
function $1329410b119241de$var$part8() {
    if ($1329410b119241de$var$prompt === "s") $1329410b119241de$var$part9();
    else {
        $1329410b119241de$var$nextPart = $1329410b119241de$var$part9;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Eco tez ! C\u2019et pa grave. Je vai me d\xe9broiller an...:00",
            "!n"
        ];
        $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
            $1329410b119241de$var$nextPart();
        });
    }
}
function $1329410b119241de$var$part9() {
    $1329410b119241de$var$nextPart = $1329410b119241de$var$part10;
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        1000,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Merde !:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Je croi qe j\u2019ai encore n probl\xe8me avec ne atre lettre:00",
        "!n",
        3000,
        "!s:col-green",
        "",
        500,
        "!t:Attendez.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Je revien:00",
        "!n",
        2000,
        "!s:italic",
        "!s:col-dark-yellow",
        "<remote host on hold>",
        "!n",
        100,
        "!s:italic",
        "!s:col-dark-yellow",
        "Please wait for remote host",
        "!t:....................:1000",
        "!n",
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Voil\xe0. Vo \xeate l\xe0 ? Je croi qe j\u2019ai trov\xe9 ne oltion.:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Mai vo devez d\u2019abord l\u2019accepter:00",
        "!n",
        500,
        "Accepter [1] Refuser [2] > "
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
        $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
        $1329410b119241de$var$enablePrompt();
    });
}
function $1329410b119241de$var$part10() {
    if ($1329410b119241de$var$prompt === "1") $1329410b119241de$var$part12();
    else {
        $1329410b119241de$var$nextPart = $1329410b119241de$var$part11;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:N'ayez pa per ! Vo ne riqez rien.:00",
            "!n",
            500,
            "Accepter tout de m\xeame [1] Refuser d\xe9finitivement [2] > "
        ];
        $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
            $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
            $1329410b119241de$var$enablePrompt();
        });
    }
}
function $1329410b119241de$var$part11() {
    if ($1329410b119241de$var$prompt === "1") $1329410b119241de$var$part12();
    else {
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Ma foi. Tant pi alor. C'et trop difficile de comm niqer aini !:00",
            "!n",
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Recontactez-moi demain i \xe7a ne vo d\xe9range pa. A revoir !:00",
            "!n",
            2000
        ];
        $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
            $1329410b119241de$var$part15();
        });
    }
}
function $1329410b119241de$var$part12() {
    $1329410b119241de$var$nextPart = $1329410b119241de$var$part13;
    const seq = [
        200,
        "!s:col-dark-green",
        "<buffering...>",
        "!n",
        800,
        "!s:col-dark-green",
        "<audio streaming enabled>",
        "!n",
        1000
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
        $8cf8d73fe06466d9$exports.play("allo", {
            onended: ()=>{
                const seq = [
                    500,
                    "Oui je vous entends [1] Non, rien dans le casque [2] > "
                ];
                $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
                    $9a5e2f4e9f369aad$export$a23ad60f6022999e("question");
                    $1329410b119241de$var$enablePrompt();
                });
            }
        });
    });
}
function $1329410b119241de$var$part13() {
    $1329410b119241de$var$nextPart = $1329410b119241de$var$part14;
    if ($1329410b119241de$var$prompt === "2") $1329410b119241de$var$part11();
    else $8cf8d73fe06466d9$exports.play("vocal", {
        onended: ()=>{
            const seq = [
                500,
                "Arr\xeater la pluie [1] > "
            ];
            $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
                $9a5e2f4e9f369aad$export$a23ad60f6022999e("success");
                $1329410b119241de$var$enablePrompt();
            });
        }
    });
}
function $1329410b119241de$var$part14() {
    //main.fullFillTask('pluie');
    $29df19f14cf0b965$export$51b36263b660c3ee(0.5);
    $8cf8d73fe06466d9$exports.play("merci", {
        onended: ()=>{
            $1329410b119241de$var$part15();
        }
    });
}
function $1329410b119241de$var$part15() {
    $9a5e2f4e9f369aad$export$a23ad60f6022999e("disconnected");
    const seq = [
        100,
        "!s:italic",
        "!s:col-dark-red",
        "<remote host disconnected>",
        "!n",
        100,
        "!s:italic",
        "!s:col-dark-red",
        "<connection closed>",
        "!n"
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
    //exit();
    });
}
function $1329410b119241de$export$5c525e238923a57d() {
    $e54f537527899e63$export$42ffd38884aecdac();
    $1329410b119241de$var$exitCallback();
}


// Variables
let $2650aeefcb3ac9c2$var$keyBoardResponsive = true;
let $2650aeefcb3ac9c2$var$address;
let $2650aeefcb3ac9c2$var$audioSource;
// Configuration
const $2650aeefcb3ac9c2$var$dialUp = true;
// Game data
const $2650aeefcb3ac9c2$var$addresses = {
    "10.1.2.124": $1329410b119241de$exports
};
function $2650aeefcb3ac9c2$export$889ea624f2cb2c57(...args) {
    $2650aeefcb3ac9c2$var$keyBoardResponsive = true;
    $2650aeefcb3ac9c2$var$address = args[0] || "";
    $e54f537527899e63$export$a1544dad697b423d();
    $e54f537527899e63$export$42ffd38884aecdac();
    // Header
    $e54f537527899e63$export$dc84f6841f96b7da();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        100,
        "AutronaTerm v2.5 - 802.11",
        "!s:col-red",
        "!s:col-bg-red",
        100,
        "!n",
        100,
        "!n"
    ];
    $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
        if ($2650aeefcb3ac9c2$var$address) {
            $e54f537527899e63$export$10d8903dec122b9d("Connecting to " + $2650aeefcb3ac9c2$var$address);
            $2650aeefcb3ac9c2$var$openConnection();
        } else {
            $e54f537527899e63$export$10d8903dec122b9d("Enter remote terminal address > ");
            $e54f537527899e63$export$58734539bbfa41a2();
        }
    });
}
function $2650aeefcb3ac9c2$var$openConnection() {
    $2650aeefcb3ac9c2$var$keyBoardResponsive = false;
    if ($2650aeefcb3ac9c2$var$address in $2650aeefcb3ac9c2$var$addresses) {
        if ($2650aeefcb3ac9c2$var$dialUp) {
            // Play modem dial up sound
            $2650aeefcb3ac9c2$var$audioSource = $8cf8d73fe06466d9$exports.play("dial-up-modem", {
                initialGain: -20
            });
            // Screen sequence. See screen.js comments for documentation
            const seq = `
                \xa71000<opening line>
                \xa7800<dialing ISP...>
                \xa74300<initiating connection...>
                \xa73900<negotiating modulation mode...>
                \xa73200<probing line...>
                \xa71400<adjusting equalizers...>

                \xa79200<connection established>

                \xa72200<muting modem>

                \xa7500<remote tty override from ${$2650aeefcb3ac9c2$var$address}>
            `.trim();
            $e54f537527899e63$export$b28a6436aebad9c0(seq, {
                color: [
                    "col-dark-green",
                    "italic"
                ],
                mode: "line",
                lineDelay: 0,
                endDelay: 0
            }, ()=>{
                setTimeout(()=>{
                    $2650aeefcb3ac9c2$var$stopSounds();
                    $2650aeefcb3ac9c2$var$addresses[$2650aeefcb3ac9c2$var$address].run($2650aeefcb3ac9c2$var$exit);
                }, 2000);
            });
        } else {
            $e54f537527899e63$export$dc84f6841f96b7da();
            // Screen sequence. See screen.js comments for documentation
            const seq = [
                100,
                "!s:col-dark-green",
                "<initiating connection...>",
                "!n",
                5160,
                "!s:col-green",
                "<connection established>",
                "!n"
            ];
            $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
                $9a5e2f4e9f369aad$export$a23ad60f6022999e("connected");
                setTimeout(()=>{
                    $2650aeefcb3ac9c2$var$stopSounds();
                    $2650aeefcb3ac9c2$var$addresses[$2650aeefcb3ac9c2$var$address].run($2650aeefcb3ac9c2$var$exit);
                }, 1000);
            });
        }
    } else {
        console.log("Bad address: " + $2650aeefcb3ac9c2$var$address);
        $2650aeefcb3ac9c2$var$address = "";
        $e54f537527899e63$export$dc84f6841f96b7da();
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            100,
            "!s:col-dark-green",
            "<initiating connection...>",
            "!n",
            5160,
            "!s:col-dark-red",
            "<unable to reach host>",
            "!n",
            100,
            "Enter remote terminal address > "
        ];
        $e54f537527899e63$export$49bb65c2ea163039(seq, ()=>{
            $9a5e2f4e9f369aad$export$a23ad60f6022999e("error");
            $e54f537527899e63$export$58734539bbfa41a2();
            $2650aeefcb3ac9c2$var$keyBoardResponsive = true;
        });
    }
}
function $2650aeefcb3ac9c2$var$stopSounds() {
    if ($2650aeefcb3ac9c2$var$audioSource) $2650aeefcb3ac9c2$var$audioSource.stop();
}
function $2650aeefcb3ac9c2$var$exit() {
    console.log("Remote program exit");
}




function $0f5fb34285e14cb8$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector(".js-start").classList.add("hidden");
        document.querySelector(".center").classList.add("hidden");
        document.querySelector(".screen").classList.remove("hidden");
        $29df19f14cf0b965$export$fbb4d68fe60c1629().then(()=>{
            $9a5e2f4e9f369aad$export$b3571188c770cc5a();
        });
    });
}
function $0f5fb34285e14cb8$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.classList.add("hidden");
    else statusEl.classList.remove("hidden");
    statusEl.innerText = status;
}
function $0f5fb34285e14cb8$export$4bb981a91e4f02eb() {
    document.querySelector(".js-start").classList.remove("hidden");
    $0f5fb34285e14cb8$export$471f7ae5c4103ae1(null);
}



var $7b763e1e57cdbc98$exports = {};
$7b763e1e57cdbc98$exports = new URL("../ui-pack.01f87fb1.aac", import.meta.url).toString();


var $f7b361566902792c$exports = {};
$f7b361566902792c$exports = new URL("../Dial_up_modem_noises.fcf212dc.aac", import.meta.url).toString();


var $5c49f0cfd47e9da1$exports = {};
$5c49f0cfd47e9da1$exports = new URL("../fan-loop.00ef9ea2.wav", import.meta.url).toString();


var $a0bb78418d0d08b7$exports = {};
$a0bb78418d0d08b7$exports = new URL("../RAIN_Heavy_loop_stereo_01.a46bc133.aac", import.meta.url).toString();


var $f6e601a046070d8a$exports = {};
$f6e601a046070d8a$exports = new URL("../HZ_Allo.df799dd6.mp3", import.meta.url).toString();


var $b86dada2593b45dc$exports = {};
$b86dada2593b45dc$exports = new URL("../HZ_Vocal.d7be1088.mp3", import.meta.url).toString();


var $0b88642d3fe9e47f$exports = {};
$0b88642d3fe9e47f$exports = new URL("../HZ_Merci.1af0b4b4.mp3", import.meta.url).toString();


const $79c59b6cf4c07d8e$var$sounds = [
    {
        name: "ui-pack",
        url: new URL($7b763e1e57cdbc98$exports)
    },
    {
        name: "dial-up-modem",
        url: new URL($f7b361566902792c$exports)
    },
    {
        name: "fan-loop",
        url: new URL($5c49f0cfd47e9da1$exports)
    },
    {
        name: "rain",
        url: new URL($a0bb78418d0d08b7$exports)
    },
    {
        name: "allo",
        url: new URL($f6e601a046070d8a$exports)
    },
    {
        name: "vocal",
        url: new URL($b86dada2593b45dc$exports)
    },
    {
        name: "merci",
        url: new URL($0b88642d3fe9e47f$exports)
    }
];
function $79c59b6cf4c07d8e$export$2cd8252107eb640b() {
    $79c59b6cf4c07d8e$var$setupMobileKeyboard();
    return $79c59b6cf4c07d8e$var$loadSounds();
}
function $79c59b6cf4c07d8e$var$loadSounds() {
    return Promise.all([
        ...$79c59b6cf4c07d8e$var$sounds.map((sound)=>{
            return $8cf8d73fe06466d9$exports.load(sound.name, sound.url);
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All sounds loaded");
    });
}
function $79c59b6cf4c07d8e$var$setupMobileKeyboard() {
    // Trigger mobile keyboard on screen click
    const screenElement = document.querySelector(".screen");
    // Focus input on screen click, raising the keyboard
    screenElement.addEventListener("click", ()=>{
        const input = document.querySelector(".mobile-input");
        input.focus();
    });
    // Prevent hitting enter submitting the mobile form for input
    document.querySelector("form").addEventListener("keypress", (e)=>e.preventDefault());
}


// Development
window.DEVMODE = true;
// Config
window.LSI = 25; // Line Sequence Interval (Used in screen.sequence and unveil
// calls for line by line time interval in milliseconds)
// Sound references
let $9a5e2f4e9f369aad$export$3f22255af92e0d9d = null;
function $9a5e2f4e9f369aad$export$a23ad60f6022999e(name) {
    // TODO: refactor this
    const effects = {
        "validate": {
            initialGain: -12,
            offset: 0.100,
            duration: 0.093
        },
        "error": {
            initialGain: -12,
            offset: 0.200,
            duration: 0.175
        },
        "success": {
            initialGain: -12,
            offset: 0.400,
            duration: 0.148
        },
        "question": {
            initialGain: -12,
            offset: 0.600,
            duration: 0.131
        },
        "notify": {
            initialGain: -12,
            offset: 0.800,
            duration: 0.340
        },
        "connected": {
            initialGain: -18,
            offset: 1.200,
            duration: 0.147
        },
        "disconnected": {
            initialGain: -18,
            offset: 1.400,
            duration: 0.297
        },
        "connecting": {
            initialGain: -18,
            offset: 1.800,
            duration: 5.160
        }
    };
    if (!(name in effects)) return console.error("Error: Uknown soundEffect: " + name);
    $8cf8d73fe06466d9$exports.play("ui-pack", effects[name]);
}
function $9a5e2f4e9f369aad$var$init() {
    $0f5fb34285e14cb8$export$2cd8252107eb640b();
    $0f5fb34285e14cb8$export$471f7ae5c4103ae1("Initializing...");
    $29df19f14cf0b965$export$2cd8252107eb640b();
    $e54f537527899e63$export$2cd8252107eb640b();
    $0f5fb34285e14cb8$export$471f7ae5c4103ae1("Loading...");
    $79c59b6cf4c07d8e$export$2cd8252107eb640b().then(()=>{
        $0f5fb34285e14cb8$export$4bb981a91e4f02eb();
    });
}
function $9a5e2f4e9f369aad$export$b3571188c770cc5a() {
    $9a5e2f4e9f369aad$export$3f22255af92e0d9d = $8cf8d73fe06466d9$exports.play("fan-loop", {
        loop: true,
        initialGain: -90
    }).fadeTo(5, -8);
    $2650aeefcb3ac9c2$export$889ea624f2cb2c57("10.1.2.124");
}
$9a5e2f4e9f369aad$var$init();


//# sourceMappingURL=index.900f2512.js.map
